import { atom, selector } from 'recoil';
import { RecoilAtomKey } from '../../recoilConstantKey';
import APIService from '../../APIService';

const WhatsAppTempFormAtom = atom({
  key: RecoilAtomKey.WhatsAppTempFormKey,
  default: {
    name: '',
    language: '',
    category: 'UTILITY',
    components: [
      {
        type: 'BODY',
        text: '',
        // example: {
        //     body_text: [[]]
        // }
      },
    ],
    param: [],
  },
});

const TempFormErrorsAtom = atom({
  key: RecoilAtomKey.TempFormErrorsKey,
  default: {},
});

const TempFormButtonsAtom = atom({
  key: RecoilAtomKey.TempFormButtonsKey,
  default: { callAction: [], quickReply: [] },
});

const callStatusListAtom = atom({
  key: RecoilAtomKey.callStatusListKey,
  default: [],
});

const templateTableStateAtom = atom({
  key: RecoilAtomKey.templateTableStateKey,
  default: {
    cache: {}, // Store data based on filters, e.g., { "page=1&search=abc": [...data] }
    totalCountCache: {}, // Store total count per filter set
    filters: {
      limit: 10,
      search: '',
      page: 0,
      sortOrder: 'desc',
      sortField: 'created_at',
      category: '',
      botNumber: '',
      organisation: '',
      keyStakeholder: '',
      status: '',
      startDate: null,
      endDate: null,
      isActive: '',
      wa_phone_number: '',
      channelObj: null,
      categoryObj: null,
      organisationObj: null,
      statusObj: null,
    },
    isLoading: false,
  },
});
const templateSummaryTableStateAtom = atom({
  key: RecoilAtomKey.templateSummaryTableStateKey,
  default: {
    cache: {},
    totalCountCache: {},
    filters: {
      template_id: '',
      search: '',
      page: 0,
      limit: 20,
      start_date: null,
      end_date: null,
      sort_by: 'sent_date',
      order: 'desc',
    },
    isLoading: false,
  },
});

export {
  WhatsAppTempFormAtom,
  callStatusListAtom,
  TempFormErrorsAtom,
  TempFormButtonsAtom,
  templateTableStateAtom,
  templateSummaryTableStateAtom,
};
